import { useFormatChannelUpdatedAt } from '@inbox-demo-nx/utils-chat-common';
import isSameDay from 'date-fns/isSameDay';
import { Text } from 'dripsy';
import { useLayoutEffect, useState } from 'react';
import { TextProps } from 'react-native';

export default function AutoUpdatingTimestamp({
  value,
  ...props
}: { value: number } & TextProps) {
  const formatChannelUpdatedAt = useFormatChannelUpdatedAt();
  const [text, setText] = useState('');

  useLayoutEffect(() => {
    setText(formatChannelUpdatedAt(value));
    if (!isSameDay(value, Date.now())) {
      return;
    }

    const id = setInterval(() => {
      if (isSameDay(value, Date.now())) {
        setText(formatChannelUpdatedAt(value));
        return;
      }
      clearInterval(id);
    }, 10000);

    return () => {
      clearInterval(id);
    };
  }, [formatChannelUpdatedAt, value]);

  return <Text {...props}>{text}</Text>;
}
